/* istanbul ignore file */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import { useHistory } from 'react-router-dom';
import HasRolePrivileges from '../../../highorder/HasRolePrivileges';
import { CrudStatus } from '../../../../utility/types/CrudStatus';
import { RaaRoles } from '../../../../utility/SecurityRules';
import {
  selectNotificationGroupList,
  selectNotificationGroupsCrudStatus,
} from '../../../../redux/slices/notificationGroupsSlice/notificationGroupsSlice';
import EmptyNotificationGroupsMessage
  from './NotificationGroupListTable/EmptyNotificationGroupsMessage/EmptyNotificationGroupsMessage';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import NotificationGroupListTable from './NotificationGroupListTable/NotificationGroupListTable';

function NotificationGroupListLayout() {
  const history = useHistory();
  const notificationGroupList = useSelector(selectNotificationGroupList);
  const crudStatus = useSelector(selectNotificationGroupsCrudStatus);
  const { activeSubscription } = useSelector(selectSessionInformation);
  const { activeTierHasAdvancedAlerting } = activeSubscription;
  const [error, setError] = useState(crudStatus === CrudStatus.ERROR);
  const handleDismissError = () => {
    setError(false);
  };

  return (
    <>
      <div className="row">
        <div className="col">
          <h2 className="mb-0">
            Notification Groups
          </h2>
        </div>
        <div className="col text-right">
          <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push('/s/actions/notification-groups/new')}
            >
              New notification group
            </button>
          </HasRolePrivileges>
        </div>
      </div>
      <hr className="my-4" />
      <div>
        {error && (
          <div className="row">
            <div className="col">
              <ErrorBanner onCloseError={handleDismissError}>
                Unexpected Error retrieving notification groups.
              </ErrorBanner>
            </div>
          </div>
        )}
        { notificationGroupList.length === 0 && crudStatus !== CrudStatus.PENDING ? (
          <EmptyNotificationGroupsMessage />
        )
          : (
            <NotificationGroupListTable />
          )}
        {
          // using advanced alerting to check if subscription tier is lower than professional
            !activeTierHasAdvancedAlerting && (
            <div className="alert alert-info rounded my-1">
              <span>
                <Icon icon="info-circle" />
                {' '}
              </span>
              {' '}
              {/* eslint-disable-next-line max-len */}
              Your current account level allows one notification action per alert. For advanced functionality including alerts that support multiple actions, repeat notifications, customized notification templates and more, consider
              {' '}
              <a href="/s/subscription/billing/change-plan">upgrading your account.</a>
            </div>
            )
        }
      </div>
    </>
  );
}

export default NotificationGroupListLayout;
